module.exports = __webpack_public_path__ + "img/3dwich_web.1a5c9868.png";